import clientSay1 from "images/clientSay5.jpg";
import clientSay4 from "images/clientSay2.png";
import clientSay5 from "images/clientSay3.png";
import clientSay6 from "images/client4.png";

export const globalJson = {
  prod_company_id: 229,
  dev_company_id: 229,

  // apiUtil auth header key
  authToken: "Bearer 168|3oLFn8OniSxk1UBTO3eQeGXMuViDTsZqAwhalwWm",
  companyId: "7514a219-48ce-439e-a2c5-6f38980cee1a",
  stripePublishableKey:
    "pk_live_51LdnoABqYa4ICTHoC6CjEgImHYOvUXXPs8psg8jZqXPxRwBt99nQEWtFFJj2n3ublkCJa0S8pYzDtvStF2JxUPzU00uWCskvlb",
  mapKey: "AIzaSyDKEntg7JydrxI7zr2tQL5OYcS5M-er-bc",
  residenceStateCode: "AZ",

  //email confirmation admin token
  adminEmailToken:
    "XR85jFku2zMMqvsYmAdkrk1lm6pozj7eFXetRHLNSSsLxRLnAHgY3dPaVsE27OK8cIbnhFQmncWxVjS1XLAhneFEFpwVVeaNE7hMOym2vrhzdKSmxn99V0fLvVJyZLPT",
  websiteLink: "https://Empire Motors-dev.1now.app",
  sender: "Empire Motors",
  ccEmail: "Empire Motors@gmail.com",

  // apiUtil sendNewsLetterEmail
  util_serviceId: "service_2xca7kj",
  util_templateId: "template_smckeo7",
  util_userId: "ATdsFr5wumje11YkV",
  util_privateKey: "TJyyV_e7nNOGPKbyyjpMB",
  util_contact_templateId: "template_9dsuz0w",

  // apiUtil getBonzahToken
  client_secret_dev: "",
  client_id_dev: "",
  client_secret_prod: "",
  client_id_prod: "",

  about_us_para:
    "AMK Elite Car Rental is a family-owned business committed to providing a seamless and premium car rental experience. We offer a curated fleet of luxury and performance vehicles, delivering to Sacramento International Airport (SMF) and other custom locations for your convenience. Whether for business, leisure, or special occasions, we take pride in delivering top-tier service tailored to your needs.",

    clientSays_arr: [
      {
        id: 1,
        clientName: "John D.",
        clientAddress: "Dodge Grand Caravan 2019",
        content:
          "The service was excellent, and the car was in top-notch condition. I'll definitely rent from here again!",
        img: clientSay1,
      },
      {
        id: 2,
        clientName: "Samantha L.",
        clientAddress: "LondDodge Grand Caravan 2019",
        content:
          "The process was so smooth, and I appreciated the friendly staff. Highly recommend this company for car rentals!",
        img: clientSay4,
      },
      {
        id: 3,
        clientName: "Michael R.",
        clientAddress: "Dodge Grand Caravan 2019",
        content:
          "The car was clean, affordable, and reliable. I had a great experience and will use them again for my next trip!",
        img: clientSay5,
      },
    ],

  //social links
  facebook: "https://www.facebook.com/",
  instagram:
    "https://www.instagram.com/bluediamond.enterprise/profilecard/?igsh=ZnNpM2t3Y2JrbDh2",

  //contact
  address: "N/A",
  operating_time: "09:00 am - 7:00 pm",
  addressLink:
    "https://www.google.com/maps/place/4830+W+Kennedy+Blvd,+Tampa,+FL+33609,+USA/data=!4m2!3m1!1s0x88c2c2e4b61fbe87:0x7fa31f86943d0895?sa=X&ved=1t:242&ictx=111",
  phone: "951-498-7677",
  email: " info@empiremotorsinc.com",
  company_name: "Empire Motors",
};

export const scriptHubSpot = document.createElement("script");
scriptHubSpot.src = "//js-na1.hs-scripts.com/46776911.js";
scriptHubSpot.async = true;
scriptHubSpot.defer = true;
scriptHubSpot.id = "hs-script-loader";
